
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.303 2.238A1 1 0 009.89.824L4.644 6.07 1.707 3.133A1 1 0 10.293 4.547l3.625 3.626c.175.174.398.27.626.29a.998.998 0 00.822-.287l5.938-5.938z","fill":"#00B127"}})])
          )
        }
      }
    